module.exports = __webpack_public_path__ + "assets/content.bcd64e31.svg";